<script>
import { format, parseISO } from 'date-fns/fp'

export default {
  name: 'CommentItem',
  props: { oneComment: { type: Object, required: true } },
  data() {
    return {}
  },
  computed: {
    commentDate() {
      return format('MMMM do, yyyy ', parseISO(this.oneComment.created_at))
    },
  },
  methods: {
    likeComment() {
      this.$emit('like-comment', this.oneComment)
    },
  },
}
</script>

<template>
  <div class="comment">
    <div class="flex justify-between">
      <div class="post-details">
        <img :src="oneComment.user.image_url" class="comment-avatar" />
        <a class="comment-author-name">{{ oneComment.user.name }}</a>
      </div>
      <div class="comment-details">
        <span class="comment-date">{{ commentDate }}</span>
        <a class="text-blue align-middle cursor-pointer" @click="likeComment"
          ><svg
            id="Layer_1"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 1000 1000"
            style="enable-background:new 0 0 1000 1000;"
            width="22"
            height="20"
            class="inline-block mr-2"
            xml:space="preserve"
          >
            <g id="Group_41" transform="translate(-1773.25 -929.5)">
              <g id="Path_38">
                <path
                  style="fill:#069BD7"
                  d="M2273.48,1876.58l-419.53-433.64c-51.25-50.11-80.71-120.14-80.7-191.99
			c0.04-148.08,120.53-268.54,268.6-268.54c0.03,0,0.04,0,0.07,0h0.05c87.94,0.04,170.44,43.15,220.67,115.32l10.8,15.54
			l10.79-15.53c9.48-13.6,20.28-26.37,32.1-37.99c105.68-103.82,276.11-102.3,379.92,3.37c50.29,51.19,77.63,118.9,77,190.66
			c-0.64,71.76-29.18,138.97-80.37,189.26l-0.03,0.03L2273.48,1876.58z M2041.85,1012.34c-131.58,0-238.65,107.03-238.68,238.62
			c-0.01,63.85,26.16,126.07,71.81,170.71l0.84,0.85l397.65,411.03l398.31-411.75c45.6-44.8,70.96-104.53,71.53-168.29
			c0.57-63.76-23.73-123.93-68.42-169.42c-92.25-93.9-243.7-95.25-337.61-3c-10.5,10.33-20.1,21.68-28.51,33.75l-35.34,50.87
			l-35.36-50.89c-44.64-64.13-117.96-102.45-196.11-102.49l-0.04-14.96l0,14.96C2041.89,1012.34,2041.87,1012.34,2041.85,1012.34z"
                />
              </g>
            </g>
          </svg>
          <span class="mr-2 align-middle">{{
            oneComment.comment_likes.length
              ? oneComment.comment_likes.length
              : ''
          }}</span></a
        >
      </div>
    </div>
    <div class="comment-content">
      {{ oneComment.content }}
    </div>
  </div>
</template>
